<section class="container">
  <div *ngIf="distributorInfo" class="text-right pull-right">
      <div *ngIf="distributorInfo.name" class="bold header-font color-black">
          {{distributorInfo | displayNameFormat}}
      </div>
      <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
        <span>{{distributorInfo.displayName | titlecase}}</span>
    </div>
      <div>
          <a *ngIf="distributorInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
          <span *ngIf="distributorInfo.distributorId">{{distributorInfo.distributorId |distributorIdFormat}}</span>
          <span *ngIf="distributorInfo.level" class="color-black"> | {{distributorInfo.level}}</span>
      </div>
  </div>
  <div class="row mb-5">
    <div class="col-md-2">
      <input #workTicket class="pointerstyle" id="{{ticketTypeName}}" tabindex="0" type="radio" name="{{ticketTypeName}}" value="{{tickets[0]}}" [(ngModel)]="ticket">
      <label class="">
        {{'customer-service.Work Ticket' |translate | translateKey}}
      </label>
    </div>
    <div class="col-md-2">
      <input #disputeTicket class="pointerstyle" id="{{ticketTypeName}}" tabindex="0" type="radio" name="{{ticketTypeName}}" value="{{tickets[1]}}" [(ngModel)]="ticket">
      <label class="">
        {{'customer-service.Dispute Ticket' |translate | translateKey}}
      </label>
    </div>
  </div> 

  <div *ngIf="tickets[0] === ticket">
    <create-work-ticket [distributorInfo]="distributorInfo" [countryCode]="countryCode" [tabIndex]="tabIndex"></create-work-ticket>
  </div>
  <div *ngIf="tickets[1] === ticket">
    <create-dispute-ticket [distributorInfo]="distributorInfo" [webOrderID]="webOrderID" [countryCode]="countryCode" [tabIndex]="tabIndex"></create-dispute-ticket>
  </div>
</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/ticket-create.component.html